export default __webpack_public_path__ + "static/media/check-circle.5f21faf3.svg";